(() => {
    const SECTION_TYPE = 'who-we-work-with';
  
    class WhoWeWorkWith {
      constructor(section) {
        this.section = section;
        this.viewport = section.querySelector('[data-wwww-viewport]');
        this.track = section.querySelector('[data-wwww-track]');
        this.nav = section.querySelector('.wwww__nav');
        this.prev = section.querySelector('[data-wwww-prev]');
        this.next = section.querySelector('[data-wwww-next]');
        if (!this.viewport || !this.track) return;
  
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.onScroll = this.onScroll.bind(this);
        this.update = this.update.bind(this);
  
        if (this.prev) this.prev.addEventListener('click', () => this.step(-1));
        if (this.next) this.next.addEventListener('click', () => this.step(1));
        this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
        this.viewport.addEventListener('keydown', (e) => this.onKey(e));
  
        this.initDrag();
  
        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(this.update);
          this.ro.observe(this.viewport);
          this.ro.observe(this.track);
        } else {
          window.addEventListener('resize', this.update);
        }
  
        this.update();
      }
  
      cards() {
        return Array.from(this.track.querySelectorAll('[data-wwww-card]'));
      }
  
      stepSize() {
        const first = this.cards()[0];
        if (!first) return 0;
        const gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap) || 0;
        return first.getBoundingClientRect().width + gap;
      }
  
      step(dir) {
        const size = this.stepSize();
        if (!size) return;
        this.viewport.scrollBy({
          left: dir * size,
          behavior: this.reducedMotion ? 'auto' : 'smooth',
        });
      }
  
      onKey(e) {
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.step(1);
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.step(-1);
        }
      }
  
      onScroll() {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = null;
          this.update();
        });
      }
  
      update() {
        const { scrollLeft, scrollWidth, clientWidth } = this.viewport;
        const max = scrollWidth - clientWidth;
        const canSlide = max > 2;
        if (this.nav) this.nav.classList.toggle('is-hidden', !canSlide);
        if (this.prev) this.prev.disabled = scrollLeft <= 2;
        if (this.next) this.next.disabled = scrollLeft >= max - 2;
      }
  
      initDrag() {
        const vp = this.viewport;
        let startX = 0;
        let startLeft = 0;
        let down = false;
        let moved = false;
  
        vp.addEventListener('pointerdown', (e) => {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          down = true;
          moved = false;
          startX = e.clientX;
          startLeft = vp.scrollLeft;
        });
  
        window.addEventListener('pointermove', (e) => {
          if (!down) return;
          const dx = e.clientX - startX;
          if (!moved && Math.abs(dx) > 4) {
            moved = true;
            vp.classList.add('is-dragging');
          }
          if (moved) vp.scrollLeft = startLeft - dx;
        });
  
        const end = () => {
          if (!down) return;
          down = false;
          if (moved) {
            vp.classList.remove('is-dragging');
            // re-snap to the nearest card
            const size = this.stepSize();
            if (size) {
              const idx = Math.round(vp.scrollLeft / size);
              vp.scrollTo({ left: idx * size, behavior: this.reducedMotion ? 'auto' : 'smooth' });
            }
          }
        };
        window.addEventListener('pointerup', end);
        window.addEventListener('pointercancel', end);
      }
  
      destroy() {
        if (this.ro) this.ro.disconnect();
      }
    }
  
    const instances = new WeakMap();
  
    const init = (root = document) => {
      root.querySelectorAll(`[data-section-type="${SECTION_TYPE}"]`).forEach((el) => {
        if (!instances.has(el)) instances.set(el, new WhoWeWorkWith(el));
      });
    };
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }
  
    document.addEventListener('shopify:section:load', (e) => init(e.target));
    document.addEventListener('shopify:section:unload', (e) => {
      const el = e.target.querySelector(`[data-section-type="${SECTION_TYPE}"]`);
      if (el && instances.has(el)) {
        instances.get(el).destroy();
        instances.delete(el);
      }
    });
  })();